export default __webpack_public_path__ + "static/media/dunes.e6340db9.jpg";